/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_LookupInputs */

const cs_kn_lookup = /** @type {(inputs: Kn_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhledat`)
};

const en_kn_lookup = /** @type {(inputs: Kn_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Look up`)
};

/**
* | output |
* | --- |
* | "Look up" |
*
* @param {Kn_LookupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_lookup = /** @type {((inputs?: Kn_LookupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_LookupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_lookup(inputs)
	return cs_kn_lookup(inputs)
});